import store from '../store';
import fun from '../assets/script/function';

export default [{
	path: '/login',
	name: 'login',
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: [{
		path: '/',
		name: 'home',
		component: () => import('@/pages/home/index')
	}, {  // 商品列表
		path: 'product_list',
		name: 'm_product_list',
		component: () => import('@/pages/product/product_list')
	}, {  // 商品审核列表
		path: 'product_audit_list',
		name: 'm_product_audit_list',
		component: () => import('@/pages/product/product_audit_list')
	}, {  // 商品发布
		path: 'product_apply',
		name: 'product_apply',
		meta: {
			title: '发布商品'
		},
		props: route => route.query,
		component: () => import('@/pages/product/product_apply')
	}, {  // 商品编辑
		path: 'product_edit/:id',
		name: 'product_edit',
		meta: {
			title: '编辑商品'
		},
		props: route => route.params,
		component: () => import('@/pages/product/product_edit')
	}, {  // 商品类目
		path: 'product_classify',
		name: 'm_product_type',
		component: () => import('@/pages/product/product_classify')
	}, {  // 商品排序
		path: 'product_sort',
		name: 'm_product_sort',
		component: () => import('@/pages/product/product_sort')
	}, {  // 商品分类
		path: 'product_group',
		name: 'm_product_group',
		component: () => import('@/pages/product/product_group')
	}, {  // 商品参数
		path: 'product_param',
		name: 'm_product_param',
		component: () => import('@/pages/product/product_param')
	}, {  // 商品属性
		path: 'product_attr',
		name: 'm_product_attr',
		component: () => import('@/pages/product/product_attr')
	}, {  // 服务标签
		path: 'product_service_tag',
		name: 'm_product_service_tag',
		component: () => import('@/pages/product/product_service_tag')
	}, {  // 定制项配置
		path: 'product_custom_config',
		name: 'm_product_custom',
		component: () => import('@/pages/product/product_custom_config')
	}, {  // 运费模板
		path: 'freight_template',
		name: 'm_freight_template',
		component: () => import('@/pages/product/freight_template')
	}, {  // 新建运费模板
		path: 'freight_template_add',
		name: 'freight_template_add',
		meta: {
			title: '新建运费模板'
		},
		component: () => import('@/pages/product/freight_template_add')
	}, {  // 编辑运费模板
		path: 'freight_template_edit/:id',
		name: 'freight_template_edit',
		meta: {
			title: '编辑运费模板'
		},
		props: route => route.params,
		component: () => import('@/pages/product/freight_template_edit')
	}, {  // 品牌管理
		path: 'product_brand',
		name: 'm_product_brand',
		component: () => import('@/pages/product/product_brand')
	}, {  // 订单列表
		path: 'order_list',
		name: 'm_order_sell',
		props: route => route.query,
		component: () => import('@/pages/order/order_detail_list')
	}, {  // 订单详情
		path: 'order_detail/:orderNumber',
		name: 'order_detail',
		meta: {
			title: '订单详情'
		},
		props: route => Object.assign({}, route.params, route.query),
		component: () => import('@/pages/order/order_detail')
		
	}, {  // 供货订单列表
		path: 'sub_order_list',
		name: 'm_sub_order',
		props: route => route.query,
		component: () => import('@/pages/order/sub_order_list')
	}, {  // 订单售后
		path: 'after_sales_apply',
		name: 'after_sales_apply',
		meta: {
			title: '申请售后'
		},
		props: route => route.query,
		component: () => import('@/pages/order/after_sales_apply')
	}, {  // 退款单列表
		path: 'refund_list',
		name: 'm_order_refund',
		props: route => route.query,
		component: () => import('@/pages/order/refund_list')
	}, {  // 退款单详情
		path: 'refund_detail/:refundNumber',
		name: 'refund_detail',
		meta: {
			title: '退款详情'
		},
		props: route => Object.assign(route.query, route.params),
		component: () => import('@/pages/order/refund_detail')
	}, {  // 售后单列表
		path: 'return_list',
		name: 'm_order_return',
		props: route => route.query,
		component: () => import('@/pages/order/return_list')
	}, {  // 售后单详情
		path: 'return_detail/:returnNumber',
		name: 'return_detail',
		meta: {
			title: '售后详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/return_detail')
	}, {  // 购买会员卡订单列表
		path: 'membership_record_list',
		name: 'm_membership_record',
		props: route => route.query,
		component: () => import('@/pages/order/membership_upgrade_record_list')
	}, {  // 购买会员卡订单详情
		path: 'membership_record/:id',
		name: 'm_membership_record_detail',
		meta: {
			title: '会员卡订单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/membership_upgrade_record_detail')
	},{  // 订单商品评价列表
		path: 'order_evaluate_list',
		name: 'm_order_evaluate',
		component: () => import('@/pages/order/order_evaluate_list')
	}, {  // 订单商品评价详情
		path: 'order_evaluate_detail/:id',
		name: 'order_evaluate_detail',
		meta: {
			title: '订单商品评价详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/order_evaluate_detail')
	}, {//用户管理
		path: 'member_list',
		name: 'm_platform_user',
		component: () => import('@/pages/member/platform_user_list')
	}, {//用户详情
		path: 'member/:platform_user_id',
		name: 'member_detail',
		meta: {
			title: '用户详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/platform_user_detail')
	}, {//用户审批
		path: 'member_apply_list',
		name: 'm_platform_user_apply',
		props: route => route.query,
		component: () => import('@/pages/member/platform_user_apply_list')
	}, {  // 会员等级列表
		path: 'user_level_list',
		name: 'm_user_level',
		component: () => import('@/pages/member/user_level_list')
	}, {  // 会员等级编辑
		path: 'user_level_edit/:id',
		name: 'level_edit',
		meta: {
			title: '编辑会员等级'
		},
		props: route => route.params,
		component: () => import('@/pages/member/user_level_edit')
	}, {  // 会员等级新增
		path: 'user_level_add',
		name: 'level_edit',
		meta: {
			title: '新增会员等级'
		},
		component: () => import('@/pages/member/user_level_edit')
	}, {  // 价格管控
		path: 'special_price_list',
		name: 'm_special_price',
		props: route => route.query,
		component: () => import('@/pages/member/special_price_list')
	}, {  // 价格管控新增页
		path: 'special_price_add',
		name: 'special_price_add',
		meta: {
			title: '申请特殊价格'
		},
		props: route => route.query,
		component: () => import('@/pages/member/special_price_add')
	}, {  // 价格管控编辑页
		path: 'special_price_edit/:id',
		name: 'special_price_edit',
		meta: {
			title: '编辑特殊价格申请'
		},
		props: route => route.params,
		component: () => import('@/pages/member/special_price_edit')
	},  {  // 价格管控详情
		path: 'special_price_detail/:id',
		name: 'special_price_detail',
		meta: {
			title: '价格管控详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/special_price_detail')
	},  {  // 价格管控审核
		path: 'special_price_verify/:id',
		name: 'special_price_verify',
		meta: {
			title: '价格管控审核'
		},
		props: route => route.params,
		component: () => import('@/pages/member/special_price_verify')
	}, {  // 认证列表
		path: 'user_auth_list',
		name: 'm_user_auth',
		props: route => route.query,
		component: () => import('@/pages/member/user_auth_list')
	},  {  // 认证详情
		path: 'user_auth_detail/:id',
		name: 'user_auth_detail',
		meta: {
			title: '会员认证详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/user_auth_detail')
	},  {  // 认证审核
		path: 'user_auth_verify/:id',
		name: 'user_auth_verify',
		meta: {
			title: '会员认证审核'
		},
		props: route => route.params,
		component: () => import('@/pages/member/user_auth_verify')
	},  {  // 用户配置
		path: 'member_config',
		name: 'm_member_config',
		component: () => import('@/pages/member/member_config')
	}, {  // 商品推荐
		path: 'recommended_list',
		name: 'm_recommended',
		component: () => import('@/pages/operation/recommended_list')
	}, {  // 商品推荐新增页
		path: 'recommended_add',
		name: 'recommended_add',
		meta: {
			title: '新增策略'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/recommended_add')
	}, {  // 商品推荐编辑页
		path: 'recommended_edit/:id',
		name: 'recommended_edit',
		meta: {
			title: '编辑策略'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/recommended_edit')
	}, {  // 热门关键字
		path: 'popular_key_words',
		name: 'm_product_popular_key_words',
		component: () => import('@/pages/operation/popular_key_words')
	}, {  // 物流公司列表
		path: 'logistics_company_list',
		name: 'm_logistics_company',
		component: () => import('@/pages/system/logistics_company_list')
	}, {  // 账号列表
		path: 'sys_user_list',
		name: 'm_sysmanage_user',
		component: () => import('@/pages/system/sys_user_list')
	}, {  // 菜单管理
		path: 'menu_manage',
		name: 'm_system_menu',
		component: () => import('@/pages/system/menu_manage')
	}, {  // 表格字段管理
		path: 'field_manage',
		name: 'm_system_menu_field',
		component: () => import('@/pages/system/field_manage')
	}, {  // 角色列表
		path: 'role_list',
		name: 'm_system_role',
		component: () => import('@/pages/system/system_role_list')
	}, {  // 新建角色
		path: 'role_add',
		name: 'role_add',
		meta: {
			title: '新建角色'
		},
		component: () => import('@/pages/system/system_role_add')
	}, {  // 编辑角色
		path: 'role_edit/:id',
		name: 'role_edit',
		meta: {
			title: '编辑角色'
		},
		props: route => route.params,
		component: () => import('@/pages/system/system_role_edit')
	}, {  // 默认验证码
		path: 'system_verify_code',
		name: 'm_system_verify_code',
		component: () => import('@/pages/system/system_verify_code')
	}, {  // 任务中心
		path: 'task_center_list',
		name: 'm_task_center_list',
		component: () => import('@/pages/system/task_center_list')
	}, {  // 售后地址列表
		path: 'after_sale_address',
		name: 'm_after_sale_address',
		component: () => import('@/pages/system/after_sale_address_list')
	}, {  // 发货地址列表
		path: 'delivery_address',
		name: 'm_delivery_address',
		component: () => import('@/pages/system/delivery_address_list')
	}, {  // 新闻列表
		path: 'newsinfo',
		name: 'm_basicinfo_news_info',
		component: () => import('@/pages/system/newsinfo')
	}, {  // 编辑新闻
		path: 'newsinfo_edit/:id',
		name: 'm_newsinfo_edit',
		meta: {
			title: '编辑新闻'
		},
		props: route => route.params,
		component: () => import('@/pages/system/newsinfo_edit')
	}, {  // 新增新闻
		path: 'newsinfo_add',
		name: 'm_newsinfo_add',
		meta: {
			title: '添加新闻'
		},
		component: () => import('@/pages/system/newsinfo_add')
	}, {  // 常见问题
		path: 'problem_list',
		name: 'm_problem',
		component: () => import('@/pages/operation/problem_list')
	},{  // 文摘咨询
		path: 'abstract_consultation',
		name: 'm_abstract_consultation',
		component: () => import('@/pages/operation/abstract_consultation')
	}, {  // 文摘咨询新增页
		path: 'abstract_consultation_add',
		name: 'abstract_consultation_add',
		meta: {
			title: '新增资讯'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/abstract_consultation_add')
	}, {  // 文摘咨询编辑页
		path: 'abstract_consultation_edit/:id',
		name: 'abstract_consultation_edit',
		meta: {
			title: '编辑资讯'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/abstract_consultation_edit')
	}, {  // 系统配置
		path: 'platform_config',
		name: 'm_platform_config',
		component: () => import('@/pages/system/platform_config')
	}, {  // 商城配置
		path: 'mall_config',
		name: 'm_mall_config',
		component: () => import('@/pages/system/mall_config')
	}, {  // 操作日志
		path: 'sys_user_log',
		name: 'm_sys_user_log',
		component: () => import('@/pages/system/sys_user_log_list')
	}, {  // 缓存列表
		path: 'cache_list',
		name: 'm_cache_info',
		component: () => import('@/pages/system/cache_list')
	}, {  // MQ错误日志
		path: 'mq_error_log',
		name: 'm_mq_error_log',
		component: () => import('@/pages/system/mq_error_log_list')
	}, {  // PC装修
		path: 'decorate_template_list_pc',
		name: 'm_decorate_template_pc',
		component: () => import('@/pages/decorate/decorate_template_pc')
	}, {  // 移动端装修模板
		path: 'decorate_template_list_wx',
		name: 'm_decorate_template_wx',
		component: () => import('@/pages/decorate/decorate_template_wx')
	}, {  // 广告管理
		path: 'advert_space_list',
		name: 'm_advert',
		component: () => import('@/pages/decorate/advert_space_list')
	}, {  // APP图标/背景
		path: 'app_style_temp_list',
		name: 'm_app_style',
		component: () => import('@/pages/decorate/app_style_temp_list')
	}, {  // APP图标/背景(编辑)
		path: 'app_style_temp_edit/:id',
		name: 'b_app_style_edit',
		meta: {
			title: '编辑APP图标/背景模板'
		},
		props: route => route.params,
		component: () => import('@/pages/decorate/app_style_temp_edit')
	}, {  // APP图标/背景(新增)
		path: 'app_style_temp_add',
		name: 'b_app_style_add',
		meta: {
			title: '新增APP图标/背景模板'
		},
		component: () => import('@/pages/decorate/app_style_temp_add')
	}, {  // APP启动页广告
		path: 'start_adv_temp_list',
		name: 'm_app_start_adv',
		component: () => import('@/pages/decorate/start_adv_temp_list')
	}, {  // APP图标/背景(编辑)
		path: 'start_adv_temp_edit/:id',
		name: 'b_app_start_adv_edit',
		meta: {
			title: '编辑APP启动广告模板'
		},
		props: route => route.params,
		component: () => import('@/pages/decorate/start_adv_temp_edit')
	}, {  // APP图标/背景(新增)
		path: 'start_adv_temp_add',
		name: 'b_app_start_adv_add',
		meta: {
			title: '新增APP启动广告模板'
		},
		component: () => import('@/pages/decorate/start_adv_temp_add')
	}, {  // 优惠券列表
		path: 'coupon_list',
		name: 'm_coupon_info',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon_list')
	},  {  // 新建优惠券
		path: 'coupon_add',
		name: 'coupon_add',
		meta: {
			title: '新建优惠券'
		},
		component: () => import('@/pages/marketing/coupon_add')
	},  {  // 编辑优惠券
		path: 'coupon_edit/:id',
		name: 'coupon_edit',
		meta: {
			title: '编辑优惠券'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_edit')
	},  {  // 优惠券详情
		path: 'coupon_detail/:id',
		name: 'coupon_detail',
		meta: {
			title: '优惠券详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_detail')
	},  {  // 优惠券审核
		path: 'coupon_verify/:id',
		name: 'coupon_verify',
		meta: {
			title: '优惠券审核'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_verify')
	}, {  // 优惠券发放任务
		path: 'coupon_task',
		name: 'm_coupon_task',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon_task')
	},  {  // 新建发放任务
		path: 'coupon_task_add',
		name: 'coupon_task_add',
		meta: {
			title: '新建发放任务'
		},
		component: () => import('@/pages/marketing/coupon_task_add')
	},  {  // 编辑发放任务
		path: 'coupon_task_edit/:id',
		name: 'coupon_task_edit',
		meta: {
			title: '编辑发放任务'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_edit')
	},  {  // 发放任务详情
		path: 'coupon_task_detail/:id',
		name: 'coupon_task_detail',
		meta: {
			title: '发放任务详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_detail')
	},  {  // 发放任务审核
		path: 'coupon_task_verify/:id',
		name: 'coupon_task_verify',
		meta: {
			title: '发放任务审核'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_verify')
	}, {  // 满赠活动列表
		path: 'reward_gift',
		name: 'm_activity_gifts',
		component: () => import('@/pages/marketing/reward_gift')
	},  {  // 新建满赠活动
		path: 'reward_gift_add',
		name: 'reward_gift_add',
		meta: {
			title: '新建满赠活动'
		},
		component: () => import('@/pages/marketing/reward_gift_add')
	},  {  // 编辑满赠活动
		path: 'reward_gift_edit/:id',
		name: 'reward_gift_edit',
		meta: {
			title: '编辑满赠活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/reward_gift_edit')
	},  {  // 满赠活动详情
		path: 'reward_gift_detail/:id',
		name: 'reward_gift_detail',
		meta: {
			title: '满赠活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/reward_gift_detail')
	}, {  // 限时折扣活动列表
			path: 'limit_time_discount',
			name: 'm_limit_time_discount',
			component: () => import('@/pages/marketing/limit_time_discount')
	},  {  // 新建限时折扣活动
			path: 'limit_time_discount_add',
			name: 'limit_time_discount_add',
			meta: {
				title: '新建限时折扣活动'
			},
			component: () => import('@/pages/marketing/limit_time_discount_add')
	},  {  // 编辑限时折扣活动
			path: 'limit_time_discount_edit/:id',
			name: 'limit_time_discount_edit',
			meta: {
				title: '编辑限时折扣活动'
			},
			props: route => route.params,
			component: () => import('@/pages/marketing/limit_time_discount_edit')
	},  {  // 限时折扣活动详情
			path: 'limit_time_discount_detail/:id',
			name: 'limit_time_discount_detail',
			meta: {
				title: '限时折扣活动详情'
			},
			props: route => route.params,
			component: () => import('@/pages/marketing/limit_time_discount_detail')
	}, {  // 砍价活动列表
			path: 'activity_bargain',
			name: 'm_activity_bargain',
			component: () => import('@/pages/marketing/activity_bargain')
	},  {  // 新建砍价活动
		path: 'activity_bargain_add',
		name: 'activity_bargain_add',
		meta: {
			title: '新建砍价活动'
		},
		component: () => import('@/pages/marketing/activity_bargain_add')
	},  {  // 编辑砍价活动
		path: 'activity_bargain_edit/:id',
		name: 'activity_bargain_edit',
		meta: {
			title: '编辑砍价活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_bargain_edit')
	},  {  // 砍价活动详情
		path: 'activity_bargain_detail/:id',
		name: 'activity_bargain_detail',
		meta: {
			title: '砍价活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_bargain_detail')
	},
	{  //预售活动列表
		path: 'activity_presell',
		name: 'm_activity_presell',
		component: () => import('@/pages/marketing/activity_presell')
	},  {  // 新建预售活动
		path: 'activity_presell_add',
		name: 'activity_presell_add',
		meta: {
			title: '新建预售活动'
		},
		component: () => import('@/pages/marketing/activity_presell_add')
	},  {  // 编辑预售活动
		path: 'activity_presell_edit/:id',
		name: 'activity_presell_edit',
		meta: {
			title: '编辑预售活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_presell_edit')
	},  {  // 预售活动详情
		path: 'activity_presell_detail/:id',
		name: 'activity_presell_detail',
		meta: {
			title: '预售活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_presell_detail')
	},
	{  //秒杀活动列表
		path: 'activity_secondkill',
		name: 'm_activity_secondkill',
		component: () => import('@/pages/marketing/activity_secondkill')
	},  {  // 新建秒杀活动
		path: 'activity_secondkill_add',
		name: 'activity_secondkill_add',
		meta: {
			title: '新建秒杀活动'
		},
		component: () => import('@/pages/marketing/activity_secondkill_add')
	},  {  // 编辑秒杀活动
		path: 'activity_secondkill_edit/:id',
		name: 'activity_secondkill_edit',
		meta: {
			title: '编辑秒杀活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_secondkill_edit')
	},  {  // 秒杀活动详情
		path: 'activity_secondkill_detail/:id',
		name: 'activity_secondkill_detail',
		meta: {
			title: '秒杀活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_secondkill_detail')
	},
	{  // 积分兑换
		path: 'pionts_product',
		name: 'm_points_product',
		component: () => import('@/pages/marketing/pionts_product')
	}, {  // 积分规则
		path: 'pionts_rule_config',
		name: 'm_points_regulation',
		component: () => import('@/pages/marketing/pionts_rule_config')
	}, {  // 积分管理明细
		path: 'pionts_record',
		name: 'm_points_recort',
		component: () => import('@/pages/marketing/pionts_record')
	}, {  // 反馈管理
		path: 'userfeedback',
		name: 'm_member_userfeedback',
		component: () => import('@/pages/system/userfeedback')
	}, {  // 地址库
		path: 'address_library',
		name: 'm_basicinfo_address_library',
		component: () => import('@/pages/system/address_library')
	}, {  // 单页管理
		path: 'article_list',
		name: 'm_article',
		component: () => import('@/pages/system/article_list')
	}, {  // APP版本管理
		path: 'app_version',
		name: 'm_app_version',
		component: () => import('@/pages/system/app_version_list')
	}, {  // APP版本管理 - 新增
		path: 'app_version_add',
		name: 'app_version_add',
		meta: {
			title: '发布APP版本'
		},
		component: () => import('@/pages/system/app_version_add')
	}, {  // APP图标/背景(编辑)
		path: 'app_version_edit/:id',
		name: 'app_version_edit',
		meta: {
			title: '编辑APP版本'
		},
		props: route => route.params,
		component: () => import('@/pages/system/app_version_edit')
	}, {  // UNI-APP版本管理
		path: 'uni_app_version',
		name: 'm_uniapp_version',
		component: () => import('@/pages/system/uniapp_version_list')
	}, {  // UNI-APP - 新增
			path: 'uniapp_version_add',
			name: 'uniapp_version_add',
			meta: {
				title: '发布UNI-APP版本'
			},
			component: () => import('@/pages/system/uniapp_version_add')
	}, {  // UNI-APP(编辑)
			path: 'uniapp_version_edit/:id',
			name: 'uniapp_version_edit',
			meta: {
				title: '编辑UNI-APP版本'
			},
			props: route => route.params,
			component: () => import('@/pages/system/uniapp_version_edit')
	}, {  // 会员账户收支记录
		path: 'member_account_record',
		name: 'm_member_account_record',
		component: () => import('@/pages/finance/member_account_record_list')
	}, {  // 会员账户收支记录详情
		path: 'member_account_record_detail/:id',
		name: 'member_account_record_detail',
		meta: {
			title: '会员收支记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_record_detail')
	}
	, {  // 会员充值记录列表
		path: 'member_recharge_record',
		name: 'm_member_recharge_record',
		component: () => import('@/pages/finance/member_recharge_record_list')
	}, {  // 会员充值记录列表详情
		path: 'member_recharge_record_detail/:id',
		name: 'member_recharge_record_detail',
		meta: {
			title: '会员充值记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_recharge_record_detail')
	}
	, {  // 授信账单列表
		path: 'member_account_credit_info',
		name: 'm_finance_member_credit_info',
		props: route => route.query,
		component: () => import('@/pages/finance/member_account_credit_info_list')
	},  {  // 授信账单详情
		path: 'member_account_credit_info_detail/:id',
		name: 'member_account_credit_info_detail',
		meta: {
			title: '授信账单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_credit_info_detail')
	}, {  // 货款补扣款
		path: 'member_account_supdeduct',
		name: 'm_member_account_supdeduct',
		component: () => import('@/pages/finance/member_account_supdeduct_list')
	}, {  // 货款补扣款详情
		path: 'member_account_supdeduct_detail/:id',
		name: 'member_account_supdeduct_detail',
		meta: {
			title: '货款补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_supdeduct_detail')
	}, {  // 佣金补扣款
			path: 'member_reward_supdeduct',
			name: 'm_member_reward_supdeduct',
			component: () => import('@/pages/finance/member_reward_supdeduct_list')
	}, {  // 佣金补扣款详情
			path: 'member_reward_supdeduct_detail/:id',
			name: 'member_reward_supdeduct_detail',
			meta: {
				title: '佣金补扣款详情'
			},
			props: route => route.params,
			component: () => import('@/pages/finance/member_reward_supdeduct_detail')
	}, {  // 积分补扣款
			path: 'member_jf_supdeduct',
			name: 'm_member_jf_supdeduct',
			component: () => import('@/pages/finance/member_jf_supdeduct_list')
	}, {  // 积分补扣款详情
			path: 'member_jf_supdeduct_detail/:id',
			name: 'member_jf_supdeduct_detail',
			meta: {
				title: '积分补扣款详情'
			},
			props: route => route.params,
			component: () => import('@/pages/finance/member_jf_supdeduct_detail')
	}, {  // 会员提现
		path: 'member_account_extract',
		name: 'm_member_account_extract',
		component: () => import('@/pages/finance/member_account_extract_list')
	}, {  // 会员提现详情
		path: 'member_account_extract_detail/:id',
		name: 'member_account_extract_detail',
		meta: {
			title: '会员提现详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_extract_detail')
	}, {  // 商家账户收支记录
		path: 'stationed_account_record',
		name: 'm_stationed_account_record',
		props: route => route.query,
		component: () => import('@/pages/finance/stationed_account_record_list')
	}, {  // 商家账户收支记录详情
		path: 'stationed_account_record_detail/:id',
		name: 'stationed_account_record_detail',
		meta: {
			title: '商家收支记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/stationed_account_record_detail')
	}, {  // 商家补扣款
		path: 'stationed_account_supdeduct',
		name: 'm_stationed_account_supdeduct',
		component: () => import('@/pages/finance/stationed_account_supdeduct_list')
	}, {  // 商家补扣款详情
		path: 'stationed_account_supdeduct_detail/:id',
		name: 'stationed_account_supdeduct_detail',
		meta: {
			title: '商家补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/stationed_account_supdeduct_detail')
	}, {  // 商家提现
		path: 'stationed_account_extract',
		name: 'm_stationed_account_extract',
		component: () => import('@/pages/finance/stationed_account_extract_list')
	}, {  // 商家提现详情
		path: 'stationed_account_extract_detail/:id',
		name: 'stationed_account_extract_detail',
		meta: {
			title: '商家提现详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/stationed_account_extract_detail')
	}, {  // 系统账户管理
		path: 'sys_account',
		name: 'm_finance_sys_account',
		component: () => import('@/pages/finance/sys_account')
	}, {  // 授权额度管理
		path: 'credit_quota',
		name: 'm_credit_quota',
		props: route => route.query,
		component: () => import('@/pages/finance/credit_quota')
	},{  // 授权额度管理详情
		path: 'credit_quota_detail/:id',
		name: 'credit_quota_detail',
		meta: {
			title: '授权额度管理详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/credit_quota_detail')
	}, {  // 系统账户收支流水
		path: 'sys_account_record/:id',
		name: 'm_finance_sys_account_record',
		meta: {
			title: '系统账户收支流水'
		},
		props: route => route.query,
		component: () => import('@/pages/finance/sys_account_record')
	}, {  //分销清分列表
		path: 'reward',
		name: 'm_reward_settlement',
		component: () => import('@/pages/finance/reward_record_list')
	}, {  //分销清分详情
		path: 'reward/detail/:orderNumber',
		name: 'reward_record_detail',
		meta: {
			title: '分销清分详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/reward_record_detail')
	}, {  // 订单清分列表
		path: 'settlement',
		name: 'm_order_settlement',
		component: () => import('@/pages/finance/order_settlement_list')
	}, {  //订单清分详情
		path: 'settlement/detail/:orderNumber',
		name: 'order_settlement_detail',
		meta: {
			title: '订单清分详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/order_settlement_detail')
	}, {  //平台补贴列表
			path: 'subsidy',
			name: 'm_subsidy_record',
			component: () => import('@/pages/finance/subsidy_record_list.vue')
	}, {  //平台补贴详情
		path: 'subsidy/detail/:orderId',
		name: 'order_subsidy_detail',
		meta: {
			title: '平台补贴详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/subsidy_record_detail')
	}, {  //区域管理收益详情列表
		path: 'region/dividend/detail',
		name: 'm_region_dividend',
		component: () => import('@/pages/finance/region_dividend_list.vue')
	}, {  //区域管理收益汇总列表
			path: 'region/dividend/summary',
			name: 'm_region_dividend_summary',
			component: () => import('@/pages/finance/region_dividend_summary_list.vue')
	}, {  // 财务配置
		path: 'finance_config',
		name: 'm_finance_config',
		component: () => import('@/pages/finance/finance_config')
	}, {  // 流量统计
		path: 'statistic_flow_list',
		name: 'm_statistic_flow',
		component: () => import('@/pages/data/statistic_flow')
	}, {  // 用户统计
		path: 'statistic_user_list',
		name: 'm_statistic_platform_user',
		component: () => import('@/pages/data/statistic_platform_user')
	},{  // 交易统计
		path: 'statistic_trans_list',
		name: 'm_statistic_trans',
		component: () => import('@/pages/data/statistic_trans')
	}, {  // 商品统计
		path: 'statistic_product_list',
		name: 'm_statistic_product',
		component: () => import('@/pages/data/statistic_product')
	}, {  // 业务员统计
		path: 'statistic_salesman_list',
		name: 'm_statistic_salesman',
		component: () => import('@/pages/data/statistic_salesman')
	}, {  // 商家管理
		path: 'stationed_user_list',
		name: 'm_srm_stationed_user',
		component: () => import('@/pages/srm/stationed_user_list')
	}, {  // 商家权限角色列表
		path: 'stationed_auth_list',
		name: 'm_srm_auth',
		component: () => import('@/pages/srm/stationed_auth_list')
	}, {  // 新建商家权限角色
		path: 'stationed_auth_add',
		name: 'stationed_auth_add',
		meta: {
			title: '新建商家角色'
		},
		component: () => import('@/pages/srm/stationed_auth_add')
	}, {  // 编辑商家权限角色
		path: 'stationed_auth_edit/:id',
		name: 'stationed_auth_edit',
		meta: {
			title: '编辑商家角色'
		},
		props: route => route.params,
		component: () => import('@/pages/srm/stationed_auth_edit')
	}, {  // 商家主营类目
		path: 'main_categories',
		name: 'm_main_categories',
		component: () => import('@/pages/srm/main_categories')
	}, {  // 经营模式
		path: 'management_model',
		name: 'm_management_model',
		component: () => import('@/pages/srm/management_model')
	}, {  // 会员管理
			path: 'member_user_list',
			name: 'm_member_user',
			component: () => import('@/pages/member/member_user_list')
	}, {  // 会员礼包
		path: 'gift_package_list',
		name: 'm_gift_package_info',
		component: () => import('@/pages/member/gift_package_list')
	}, {  // 会员礼包新增页
		path: 'gift_package_add',
		name: 'gift_package_add',
		meta: {
			title: '新增会员礼包'
		},
		props: route => route.query,
		component: () => import('@/pages/member/gift_package_add')
	}, {  // 会员礼包编辑页
		path: 'gift_package_edit/:id',
		name: 'gift_package_edit',
		meta: {
			title: '编辑会员礼包'
		},
		props: route => route.params,
		component: () => import('@/pages/member/gift_package_edit')
	}, {  // 会员礼包详情页
		path: 'gift_package_detail/:id',
		name: 'gift_package_detail',
		meta: {
			title: '会员礼包详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/gift_package_detail')
	}, {  // 分销设置
		path: 'distribution_config',
		name: 'm_share',
		props: route => route.params,
		component: () => import('@/pages/member/distribution_config')
	}, {  // 区域配置
			path: 'region',
			name: 'm_region',
			props: route => route.params,
			component: () => import('@/pages/member/region_list')
	}, {  // 经销商管理
		path: 'seller_user_list',
		name: 'm_seller_stationed_user',
		component: () => import('@/pages/seller/stationed_user_list')
	}, {  // 经销商权限角色列表
		path: 'seller_auth_list',
		name: 'm_seller_auth',
		component: () => import('@/pages/seller/stationed_auth_list')
	}, {  // 新建经销商权限角色
		path: 'seller_auth_add',
		name: 'seller_auth_add',
		meta: {
			title: '新建经销商角色'
		},
		component: () => import('@/pages/seller/stationed_auth_add')
	}, {  // 编辑商经销商权限角色
		path: 'seller_auth_edit/:id',
		name: 'seller_auth_edit',
		meta: {
			title: '编辑经销商角色'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/stationed_auth_edit')
	}, {  // 经销商商品列表
		path: 'seller_product_list',
		name: 'm_seller_product_list',
		component: () => import('@/pages/seller/product_list')
	}, {  // 经销商订单列表
		path: 'seller_order_list',
		name: 'm_seller_order_sell',
		props: route => route.query,
		component: () => import('@/pages/seller/order_list')
	}, {  // 经销商退款单列表
		path: 'seller_refund_list',
		name: 'm_seller_order_refund',
		props: route => route.query,
		component: () => import('@/pages/seller/refund_list')
	}, {  // 经销商售后单列表
		path: 'seller_return_list',
		name: 'm_seller_order_return',
		props: route => route.query,
		component: () => import('@/pages/seller/return_list')
	},{  // 经销商交易统计
		path: 'seller_statistic_trans_list',
		name: 'm_seller_statistic_trans',
		component: () => import('@/pages/seller/statistic_trans')
	}, {  // 经销商商品统计
		path: 'seller_statistic_product_list',
		name: 'm_seller_statistic_product',
		component: () => import('@/pages/seller/statistic_product')
	}
	, {  // 经销商账户收支记录
		path: 'seller_account_record',
		name: 'm_seller_account_record',
		props: route => route.query,
		component: () => import('@/pages/seller/account_record_list')
	}, {  // 经销商补扣款
		path: 'seller_account_supdeduct',
		name: 'm_seller_account_supdeduct',
		component: () => import('@/pages/seller/account_supdeduct_list')
	}, {  // 经销商补扣款详情
		path: 'seller_account_supdeduct_detail/:id',
		name: 'seller_account_supdeduct_detail',
		meta: {
			title: '经销商补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/account_supdeduct_detail')
	}, {  // 经销商提现
		path: 'seller_account_extract',
		name: 'm_seller_account_extract',
		component: () => import('@/pages/seller/account_extract_list')
	}, {  // 经销商提现详情
		path: 'seller_account_extract_detail/:id',
		name: 'seller_account_extract_detail',
		meta: {
			title: '经销商提现详情'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/account_extract_detail')
	}, {  // 经销商订单清分列表
		path: 'seller_settlement',
		name: 'm_seller_order_settlement',
		component: () => import('@/pages/seller/order_settlement_list')
	}, {  // 云仓库存
		path: 'cloud_stock',
		name: 'm_cloud_stock',
		component: () => import('@/pages/member/cloud_stock_list')
	}, {  // 云仓库存台账
		path: 'cloud_stock_log',
		name: 'm_cloud_stock_log',
		component: () => import('@/pages/member/cloud_stock_log_list')
	},  {  // 云仓提货
		path: 'lade_user_stock/:user_id',
		name: 'b_member_user_stock_lade',
		meta: {
			title: '云仓提货'
		},
		props: route => route.params,
		component: () => import('@/pages/member/lade_user_stock')
	}, {
		path: 'list',
		name: 'listName',
		meta: {
			title: '列表'
		},
		component: () => import('@/pages/demo/list')
	}, {
		path: 'form',
		name: 'formName',
		meta: {
			title: '表单'
		},
		component: () => import('@/pages/demo/form')
	}, {
		path: 'detail',
		name: 'detailName',
		meta: {
			title: '详情'
		},
		component: () => import('@/pages/demo/detail')
	}, {  // 素材库
			path: 'media/catalog/list',
			name: 'm_media_catalog',
			component: () => import('@/pages/operation/media_catalog_list')
		}, {  // 素材库-新增页
			path: 'media/catalog/add',
			name: 'media_catalog_add',
			meta: {
				title: '新增素材'
			},
			props: route => route.query,
			component: () => import('@/pages/operation/media_catalog_add')
		}, {  // 素材库-编辑页
			path: 'media/catalog/edit/:id',
			name: 'media_catalog_edit',
			meta: {
				title: '编辑素材'
			},
			props: route => route.params,
			component: () => import('@/pages/operation/media_catalog_edit')
		}, {  // 资源库
			path: 'media/resource/list',
			name: 'm_media_resource',
			component: () => import('@/pages/operation/media_resource_list')
		}]
}, {
	path: '/decorate_manage/:type',
	name: 'decorate_manage',
	meta: {
		title: '装修系统'
	},
	props: route => Object.assign(route.query, route.params),
	component: () => import('@/submodule/decorate_manage/index')
}, {
	path: '/oss_manage',
	name: 'oss_manage',
	meta: {
		title: '图片空间'
	},
	component: () => import('@/submodule/oss_manage/index')
}, {
	path: '*',
	redirect: '/'
}];